import React from 'react';
import { Platform, View } from 'react-native';
import { tw } from '../../utils/tailwind';
import { PrinterTable } from './printer-table';
import { useT } from '../../utils/helper';
import BluetoothSettings from '../../utils/bluetooth-settings';
import { TouchableOpacity } from '../../components/forms';
import { useBluetoothPrinter } from '../../contexs/bluetooth-printer-context';

export const PrinterListScreen = () => {
  // Standard hooks
  const t = useT('screens', { keyPrefix: 'PrinterList' });
  const { initiateDiscovery } = useBluetoothPrinter();

  const isWeb = Platform.OS === 'web' && !window.ReactNativeWebView;

  return (
    <View style={tw`w-full max-w-[540px] self-center p-2`}>
      <View style={tw`gap-y-5 mt-3`}>
        {isWeb ? null : (
          <View style={tw`flex-row justify-between`}>
            <TouchableOpacity
              label={t('pairPrinter').toString()}
              onPress={() => BluetoothSettings.open()}
              theme="blue"
              extraStyle="py-2 rounded-[10px]"
              extraLabelStyle="text-base normal-case leading-normal"
            />
            <TouchableOpacity
              label={t('scanPairedPrinters').toString()}
              onPress={initiateDiscovery}
              theme="blue"
              extraStyle="py-2 rounded-[10px]"
              extraLabelStyle="text-base normal-case leading-normal"
            />
          </View>
        )}

        <PrinterTable />
      </View>
    </View>
  );
};
